import { useCallback, useMemo } from "react";

import { TabSources } from "@/constants/analytics/Tabs";
import { LearnMoreResource, ListEmptyCTAText } from "@/constants/Schedule";
import useBookingAnalytics from "@/hooks/useBookingAnalytics";
import useAppMonitor from "@/services/AppMonitor";
import SectionEmptyListCard from "@/ui/composed/cards/SectionEmptyListCard";
import { openUrl } from "@/utils/navigation.util";

interface EmptyListCardProps {
  handleBookAppointment: () => void;
  shouldShowBookAppointment?: boolean;
}

const EmptyListCard = ({
  handleBookAppointment,
  shouldShowBookAppointment,
}: EmptyListCardProps) => {
  const { trackLearnMore } = useBookingAnalytics();
  const { captureException } = useAppMonitor();
  const handleLearnMore = useCallback(() => {
    void openUrl({
      onError: (error?: Error) => {
        captureException(
          new Error("Failed to open Schedule Tab Learn More URL", {
            cause: error,
          }),
        );
      },
      url: LearnMoreResource.url,
    });
    trackLearnMore(TabSources.Schedule);
  }, [captureException, trackLearnMore]);

  const emptyListCardProps = useMemo(
    () =>
      shouldShowBookAppointment
        ? {
            buttonTitle: ListEmptyCTAText.BookAppointment,
            description: ListEmptyCTAText.InTreatmentCTA,
            onButtonPress: handleBookAppointment,
            title: ListEmptyCTAText.NoEvents,
          }
        : {
            buttonTitle: ListEmptyCTAText.LearnMore,
            description: ListEmptyCTAText.NotInTreatmentCTA,
            onButtonPress: handleLearnMore,
            title: ListEmptyCTAText.NoAppointments,
          },
    [handleBookAppointment, handleLearnMore, shouldShowBookAppointment],
  );

  const {
    buttonTitle,
    description,
    onButtonPress: handleButtonPress,
    title,
  } = emptyListCardProps;
  return (
    <SectionEmptyListCard
      buttonTitle={buttonTitle}
      description={description}
      onButtonPress={handleButtonPress}
      title={title}
    />
  );
};

export type { EmptyListCardProps };
export default EmptyListCard;
